import { useMutation } from "@tanstack/react-query";
import { resetPassword } from "../../apis/auth";

type ResetPasswordParams = {
  email: string;
  code: string;
  password: string;
  confirmPassword: string;
  mode?: "business" | "admin";
};

export function useResetPassword() {
  const { mutate, data, error, status } = useMutation({
    mutationFn: ({
      email,
      code,
      password,
      confirmPassword,
      mode,
    }: ResetPasswordParams) => {
      return resetPassword(email, code, password, confirmPassword, mode);
    },
  });

  return {
    resetPassword: mutate,
    result: data,
    error,
    status,
    isLoading: status === "pending",
  };
}
